import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  AuthService,
  AuthStorageService,
  BaseSiteService,
  CsrfStateService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core';
import { LoginFormComponent } from '@spartacus/user/account/components';
import { distinctUntilKeyChanged, filter, map } from 'rxjs/operators';
import { ForgotPasswordService } from 'src/app/services/feature/forgot-pwd/forgot-password.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { kbOneTrustInitService } from 'src/app/services/OneTrust/oneTrust.service';
import { Subscription } from 'rxjs';
const GLOBAL_MSG_ERROR = '[GlobalMessage] Error';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../services/environment.service';
import { isPlatformBrowser } from '@angular/common';
import { KBLoginFormComponentService } from './login-form-component.service';
@Component({
  selector: 'app-kb-login',
  templateUrl: './kb-login.component.html',
  styleUrls: ['./kb-login.component.scss'],
  standalone: false,
  host: { ngSkipHydration: 'true' },
})
export class KbLoginComponent extends LoginFormComponent {


  /** UI flags */
  rememberLogIn = false;
  csrfToken?: string;
  csrfLoading = false;
  loginSubmitting = false;
  showCookiePopup = false;
  /** misc (kept from your original) */
  errorMsg = false;
  emailSent = false;
  baseSite!: string;
  FunctionalCookies = true;
  resetpwdFlag = true;
  subscription = new Subscription();
  private destroy$ = new Subject<void>();
  platformId = inject(PLATFORM_ID);
  private idleTimer: any;
  private readonly onMouseMove = () => this.resetIdleTimer();
  private readonly onKeyDown = () => this.resetIdleTimer();
  constructor(
    service: KBLoginFormComponentService,
    protected router: Router,
    private globalmsg: GlobalMessageService,
    private matdialog: MatDialog,
    private forgotpwdService: ForgotPasswordService,
    private cdr: ChangeDetectorRef,
    private baseSiteService: BaseSiteService,
    private AuthLocalService: AuthStorageService,
    private oneTrust: kbOneTrustInitService,
    private enviornmentService: EnvironmentService,


    private authService: AuthService,
    protected csrfStateService: CsrfStateService
  ) {
    super(service);
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.startIdleTimer();
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('keydown', this.onKeyDown);
    }
    this.subscription.add(this.forgotpwdService.successMsg$.subscribe((x) => {
      this.emailSent = x;
      this.cdr.detectChanges();
    }));
    this.subscription.add(this.baseSiteService.getActive().subscribe((baseSiteName) => {
      this.baseSite = baseSiteName;
    }));
    this.forgotpwdService.canSetNewCountry(false);

    this.subscription.add(this.oneTrust.consentChangedCustom$().subscribe((x: any) => {
      this.FunctionalCookies = x.get('FunctionalCookies') === true;
      this.cdr.detectChanges();
    }));
    this.subscription.add(this.globalmsg.get().subscribe((x) => {
      const errorMessage = x;
      const errorMessages = errorMessage[GLOBAL_MSG_ERROR];
      if ((errorMessages?.length ?? 0) >= 1 && this.resetpwdFlag) {
        this.form.patchValue({ password: '' });
        this.resetpwdFlag = false;
      }
    }));
  }
  ngAfterViewChecked() {
    this.subscription.add(
      this.globalmsg
        .get()
        .pipe(
          distinctUntilKeyChanged('httpHandlers.badRequest.bad_credentials'),
          filter(
            (errorMessage) => errorMessage[GLOBAL_MSG_ERROR] && errorMessage[GLOBAL_MSG_ERROR]?.length > 1
          ),
          map((errorMessage) => {
            return errorMessage[GLOBAL_MSG_ERROR];
          })
        )
        .subscribe((errorMessages) => {
          if (
            errorMessages[1].key == 'httpHandlers.badRequest.user_is_disabled' &&
            errorMessages[0].key == 'httpHandlers.badRequest.bad_credentials'
          ) {
            this.globalmsg.remove(GlobalMessageType.MSG_TYPE_ERROR, 0);
          }
        })
    );
  }
  override onSubmit(): void {
    const userId = this.form.get('userId')?.value;

    if (userId) {
      if (isPlatformBrowser(this.platformId)) {
        sessionStorage.setItem('loginUserId', userId);
      }

    }
    this.authService.getCsrfToken().subscribe((token) => {
      this.csrfStateService.set(token);
      super.onSubmit();
      this.resetpwdFlag = true;
    });
  }
  closeError() {
    this.errorMsg = false;
  }
  rememberMe(event: Event) {
    this.rememberLogIn = event.target['checked'];
  }

  navigateToRegister() {
    this.router.navigate(['/register']);
  }
  openForgotPwd() {
    this.matdialog.open(ForgotPasswordComponent);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.forgotpwdService.sendSuccessMsg(false);
    let refreshToken;
    this.subscription.add(this.AuthLocalService.getToken().subscribe((x) => {
      if (x.access_token && x.refresh_token) {
        refreshToken = x.refresh_token;
        if (this.rememberLogIn) {
          this.forgotpwdService.setRefreshToken(refreshToken);
        }
      }
    }));
    this.forgotpwdService.canSetNewCountry(true);
    this.subscription.unsubscribe();
    if (isPlatformBrowser(this.platformId)) {
      clearTimeout(this.idleTimer);
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('keydown', this.onKeyDown);
    }
  }
  startIdleTimer() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.idleTimer = setTimeout(() => {
      console.log('Login page idle redirecting to home');
      this.router.navigate(['/']);
    }, 299000); // 10 minutes
  }

  resetIdleTimer() {
    if (isPlatformBrowser(this.platformId)) {
      clearTimeout(this.idleTimer);
      this.startIdleTimer();
    }
  }
}
